import {
    getNativeWebViewAccessToken,
    isEmbeddedNativeWebView,
} from "@albertine/wrapper-interop";
import {
    DEV_MEMBER_LOGIN_ENABLED,
    usesDevMemberLogin,
} from "./devMemberLogin/devMemberLoginEnabled";
import {
    getKeycloakTokenFromParentFrame,
    type ParentFrameTokenOptions,
} from "./iframeKeycloakToken";
import { isEmbeddedInParentFrame } from "./parentFrame";

export async function getKeycloakToken(
    options?: ParentFrameTokenOptions,
): Promise<string | null> {
    if (isEmbeddedInParentFrame()) {
        return getKeycloakTokenFromParentFrame(options);
    }

    if (isEmbeddedNativeWebView()) {
        const nativeToken = await getNativeWebViewAccessToken();
        if (nativeToken) {
            return nativeToken;
        }
    }

    if (DEV_MEMBER_LOGIN_ENABLED && usesDevMemberLogin()) {
        const { getDevMemberAccessToken } = await import(
            "./devMemberLogin/devMemberLogin"
        );
        return getDevMemberAccessToken(options);
    }

    return null;
}
